// v-adjust-position.ts

declare global {
  interface HTMLElement {
    __adjustResizeHandler__?: (event: UIEvent) => void;
  }
}

const adjustPosition = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();
  const parentRect = el.parentElement?.getBoundingClientRect();
  if (!parentRect) return;

  //window.innerWidth for global
  const maxWidth = parentRect.width;
  if (rect.right > maxWidth) {
    // Align to the right if overflowing
    el.style.left = 'auto';
    el.style.right = '0';
  } else {
    el.style.left = '';
    el.style.right = '';
  }
};

const vAdjustPosition = {
  mounted(el: HTMLElement) {
    // Adjust on mount
    adjustPosition(el);
    // Assign resize handler (use explicit type as HTMLElement now accepts this property)
    (el as HTMLElement).__adjustResizeHandler__ = () => adjustPosition(el);
    window.addEventListener('resize', el.__adjustResizeHandler__!);
  },
  unmounted(el: HTMLElement) {
    window.removeEventListener('resize', el.__adjustResizeHandler__!);
    delete el.__adjustResizeHandler__;
  }
};

export default vAdjustPosition;
